<template>
  <div class="app-container seo-seed-page">
    <el-card shadow="never">
      <div class="-mb-16px">
        <el-form
          ref="searchRefs"
          :model="params"
          size="small"
          label-width="70px"
          inline
        >
          <el-form-item label="站点" prop="site_id">
            <el-select
              v-model="params.site_id"
              filterable
              placeholder="全部站点"
              class="w-220px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in siteOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主词" prop="seed_keyword">
            <el-input
              v-model="params.seed_keyword"
              placeholder="请输入主词"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="params.status"
              placeholder="全部状态"
              class="w-120px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="停用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="ml-6px">
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="mt-16px" shadow="never" v-loading="pager.loading">
      <div>
        <el-button
          v-if="$hasPermission('seo.seed', 'create')"
          type="primary"
          size="small"
          @click="onNew"
        >
          新增主词
        </el-button>
      </div>
      <div class="mt-16px">
        <el-table :data="pager.list">
          <el-table-column prop="id" label="ID" width="70"></el-table-column>
          <el-table-column
            prop="site_name"
            label="站点"
            width="150"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="seed_keyword"
            label="主词"
            min-width="160"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="target_domain"
            label="目标域名"
            width="180"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="地区/语言/设备" width="190">
            <template v-slot="scope">
              <span>{{ scope.row.location_name || "-" }}</span>
              <span class="ml-6px">{{ scope.row.language_code }}</span>
              <span class="ml-6px">{{ deviceText(scope.row.device) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="keyword_count"
            label="拓词数"
            width="80"
          ></el-table-column>
          <el-table-column label="状态" width="80">
            <template v-slot="scope">
              <el-tag size="small" v-if="scope.row.status === 1">正常</el-tag>
              <el-tag size="small" type="danger" v-else>停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="160">
            <template v-slot="scope">
              {{ formatDate(scope.row.create_time, "yyyy-mm-dd hh:MM:ss") }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template v-slot="scope">
              <el-button
                v-if="$hasPermission('seo.seed', 'edit')"
                type="text"
                @click="onEdit(scope.row.id)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex justify-between mt-16px">
        <div></div>
        <pagination
          v-model="pager"
          :pageSizes="[10, 20, 30]"
          @change="getList()"
        ></pagination>
      </div>
    </el-card>

    <seed-dialog ref="seedDialog" @refresh="getList"></seed-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import { Pager } from "@/utils/pager";
import { formatDate } from "@/utils/util";
import { apiSeoSeedList, apiSeoSiteOptions } from "@/api/seo";
import SeedDialog from "../keyword/seed-dialog.vue";

export default {
  components: {
    Pagination,
    SeedDialog,
  },
  data() {
    return {
      siteOptions: [],
      params: {
        site_id: "",
        seed_keyword: "",
        status: "",
      },
      pager: new Pager(),
    };
  },
  created() {
    this.getSiteOptions();
    this.getList();
  },
  methods: {
    formatDate,
    getSiteOptions() {
      apiSeoSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    getList(page) {
      page && (this.pager.page = page);
      this.pager.request({
        callback: apiSeoSeedList,
        params: { ...this.params },
      });
    },
    onReset() {
      this.$refs.searchRefs.resetFields();
      this.getList(1);
    },
    onNew() {
      this.$refs.seedDialog.openDialog();
    },
    onEdit(id) {
      this.$refs.seedDialog.openDialog(id);
    },
    deviceText(device) {
      return device === "mobile" ? "移动端" : "桌面端";
    },
  },
};
</script>
